import { SuccessScreen } from '../PayRent/SuccessScreen';
import { FailureScreen } from '../PayRent/FailureScreen';
import { PayRentTypes } from '../../PayRentTypes';
import React from 'react';

export const PaymentResultScreen = ({
  paidAmount,
  authCode,
  balanceDue,
  errorDetails,
  tenantMail,
  clickHandler,
  is_successful,
}: PayRentTypes.TPaymentResultScreen) => {
  const getProperScreen = () => {
    if (is_successful) {
      return (
        <SuccessScreen
          paidAmount={paidAmount}
          balanceDue={balanceDue}
          authCode={authCode}
          tenantMail={tenantMail}
          clickHandler={clickHandler}
        />
      );
    } else {
      return (
        <FailureScreen
          clickHandler={clickHandler}
          errorDetails={errorDetails}
        />
      );
    }
  };

  return <>{getProperScreen()}</>;
};
